export class LoggingAnalyticsHandler {
  trackPageView(url) {
    console.log('Analytics page view:', url);
  }
}

// Check if the user has accepted analytics cookies via the cookie consent helper
const isAnalyticsConsentGiven = () => {
  if (typeof window === 'undefined') return false;
  // Use the central helper from index.html if available
  if (window.cookieconsent?.getConsent) {
    return window.cookieconsent.getConsent()?.analytics === true;
  }
  // Fallback to direct localStorage if helper is not yet initialized
  try {
    const consent = JSON.parse(localStorage.getItem('cookieconsent'));
    return consent?.analytics === true;
  } catch {
    return false;
  }
};

// Google Analytics 4 (GA4) using gtag.js script, which is included in util/includeScripts.js
export class GoogleAnalyticsHandler {
  trackPageView(canonicalPath, previousPath) {
    // GDPR: Only track if user has given analytics consent
    if (!isAnalyticsConsentGiven()) {
      return;
    }

    // GA4 property. Manually send page_view events
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    // Note 1: You should turn "Enhanced measurement" off.
    //         It attaches own listeners to elements and that breaks in-app navigation.
    // Note 2: If previousPath is null (just after page load), gtag script sends page_view event automatically.
    //         Only in-app navigation needs to be sent manually from SPA.
    // Note 3: Timeout is needed because gtag script picks up <title>,
    //         and location change event happens before initial rendering.
    if (previousPath && window.gtag) {
      window.setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
        });
      }, 300);
    }
  }
}
